import { Response } from '@marketplace-web/shared/api-client'

import { PackageSizesResp } from 'types/api/response/package-sizes-resp'

import { transformPackageSizeDto } from 'data/transformers/package-sizes'

export const transformPackageSizesResponse = (response: Response<PackageSizesResp>) => ({
  packageSizes: response.package_sizes.map(transformPackageSizeDto),
  parcelMeasurements: {
    enabled: response.parcel_measurements.enabled,
    suggestion: response.parcel_measurements.suggestion,
  },
})
